<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { getUrlUserInfo } from '@/common/common'
export default {
  name: 'App',
  data() {
    return {}
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  },
  async mounted() {
    // const name = await getUrlUserInfo(window.location.href)
    // if (this.isMobile()) {
    //   console.log('手机端')
    //   console.log(name)
    //   console.log(this.$route)
    //   console.log(this.$root.$route)
    //   // window.location = `https://app.weilian.xin/m/index?sup=PBneG9rm7Lv2Nm0J`
    // } else {
    //   // alert('pc端')
    // }
  }
}
</script>

<style lang="less">
@import 'common/Less/index';

body {
  margin: 0;
  padding: 0;
  background: @bgColor !important;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
  margin: 0 auto;
  // width: @pcWidth;
  height: @pcHeight;
}
</style>



// WEBPACK FOOTER //
// src/App.vue